import { render, staticRenderFns } from "./ScreenTabFilteringStatusBar.vue?vue&type=template&id=5486a09e&scoped=true&"
import script from "./ScreenTabFilteringStatusBar.vue?vue&type=script&lang=js&"
export * from "./ScreenTabFilteringStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTabFilteringStatusBar.vue?vue&type=style&index=0&id=5486a09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486a09e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
